module.exports = __webpack_public_path__ + "img/tu_26.c43122bc.jpg";